<template>
  <v-card>
    <v-card-title class="headline">Gửi thông báo tới {{ userName }}</v-card-title>
    <v-card-text>
      <v-select
        :items="templateOptions"
        label="Mẫu thông báo"
        :item-value="item => {
          return {
            title: item.title,
            content: item.content
          }
        }"
        item-text="title"
        @change="onChangeTemplate"
      ></v-select>
    <v-form v-model="form.isValid" ref="form">
      <v-text-field
        v-model="form.title"
        :rules="[validate.required]"
        label="Tiêu đề"
      ></v-text-field>
      <v-textarea
        v-model="form.content"
        :rules="[validate.required]"
        label="Nội dung"
      ></v-textarea>
    </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="close">Hủy</v-btn>
      <v-btn color="primary" dark @click="sendNotificationSubmit" :loading="loading">Gửi</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import validate from '@/utils/validate';
import { mapActions } from 'vuex';

export default {
  props: {
    user: {
      type: Object,
      default: null
    },
  },
  data () {
    return {
      validate: validate,
      form: {
        title: '',
        content: ''
      },
      loading: false,
      templateOptions: [
        {
          title: 'Motrak Thông báo',
          content: 'Kiểm tra tính năng nhận thông báo cho tài khoản {{userName}} vào lúc {{dateTime}}!'
        },
      ]
    };
  },
  computed: {
    userName () {
      return this.user ? this.user.name : '';
    }
  },
  methods: {
    ...mapActions(['sendNotificationToUser']),
    close () {
      this.$emit('close');
      this.reset();
    },
    reset () {
      this.form.title = '';
      this.form.content = '';
      this.$refs.form.reset();
    },
    onChangeTemplate (template) {
      this.form.title = template.title;

      const dateTime = new Date().toLocaleString('en-GB', { hour12: false });
      this.form.content = template.content.replace('{{userName}}', this.userName).replace('{{dateTime}}', dateTime);
    },
    sendNotificationSubmit () {
      if (this.form.isValid) {
        this.loading = true;
        const body = {
          userId: this.user.id,
          title: this.form.title,
          content: this.form.content
        };
        this.sendNotificationToUser(body)
          .then(_ => {
            this.loading = false;
            window.getApp.showMessage('Gửi thông báo thành công', 'success');
            this.close();
          })
          .catch(_ => {
            this.loading = false;
            window.getApp.showMessage('Gửi thông báo thất bại', 'error');
          });
      } else {
        this.$refs.form.validate();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/account/components/SendNotification.vue